/**
 * Structured errors. Throwing strings is an anti-pattern — structured errors
 * let the UI show "this schema uses a feature we don't support yet" instead of
 * a generic stack trace.
 */

export class SchemaEngineError extends Error {
  readonly code: string;
  readonly pathPointer: string | undefined;

  constructor(code: string, message: string, pathPointer?: string) {
    super(message);
    this.name = 'SchemaEngineError';
    this.code = code;
    this.pathPointer = pathPointer;
  }
}

export class UnsupportedSchemaError extends SchemaEngineError {
  constructor(feature: string, pathPointer?: string) {
    super('UNSUPPORTED_SCHEMA', `Unsupported schema feature: ${feature}`, pathPointer);
    this.name = 'UnsupportedSchemaError';
  }
}

export class RefResolutionError extends SchemaEngineError {
  constructor(ref: string, pathPointer?: string) {
    super('REF_RESOLUTION', `Could not resolve $ref: ${ref}`, pathPointer);
    this.name = 'RefResolutionError';
  }
}

export class InvalidPointerError extends SchemaEngineError {
  constructor(pointer: string) {
    super('INVALID_POINTER', `Invalid JSON pointer: ${pointer}`, pointer);
    this.name = 'InvalidPointerError';
  }
}
